<template>
  <div class="v-wrap">

    <div class="v-controls">
      <ring-category-nav class="v-controls__category" />

      <div class="v-controls__filter" v-if="!( ['/set_rings'].includes($pathname) )">
        <filter-drawer
          :photoMode="photoMode"
          :bgMode="bgMode"
          :designs="designs"
          :selectedDesigns="selectedDesigns"
          :tastes="tastes"
          :selectedTastes="selectedTastes"
          :metals="metals"
          :selectedMetals="selectedMetals"
          :textures="textures"
          :selectedTextures="selectedTextures"
          :series="series"
          :selectedSeries="selectedSeries"
          :otherFilters="otherFilters"
          :selectedOtherFitlers="selectedOtherFitlers"
          :types="types"
          :$pathname="$pathname"
          @update:photoMode="photoMode = $event"
          @update:bgMode="bgMode = $event"
          @update-item="onItemClick"
          @clear-all="onClearClick"
        ></filter-drawer>
      </div>
    </div>

    <div class="v-results">
      <router-view
        :key="$route.fullPath"
        :currentPage="currentPage"
        :selectedDesigns="selectedDesigns"
        :selectedTastes="selectedTastes"
        :selectedMetals="selectedMetals"
        :selectedTanzos="selectedTanzos"
        :selectedTextures="selectedTextures"
        :selectedDiamonds="selectedDiamonds"
        :selectedTypes="selectedTypes"
        :selectedSeries="selectedSeries"
        :selectedOtherFitlers="selectedOtherFitlers"
        :selectedEc="selectedEc"
        :photoMode="photoMode"
        :bgMode="bgMode"
        @incrementCurrentPage="currentPage = currentPage + 1"
      />
    </div>

  </div>
</template>

<script>
import { Http } from '../../../http'
import FilterList from './FilterList.vue'
import FilterAccordion from './FilterAccordion.vue'
import RingCategoryNav from './RingCategoryNav.vue'
import FilterDrawer from './FilterDrawer.vue'


export default {
  name: 'Main',

  components: { FilterList, RingCategoryNav, FilterAccordion, FilterDrawer, },

  data () {
    return {
      designs: [],
      selectedDesigns: [],
      tastes: [],
      selectedTastes: [],
      metals: [],
      selectedMetals: [],
      tanzos: [],
      selectedTanzos: [],
      textures: [],
      selectedTextures: [],
      diamonds: [],
      selectedDiamonds: [],
      types: [],
      selectedTypes: [],
      series: [],
      selectedSeries: [],
      otherFilters: [],
      selectedOtherFitlers: [],
      ec: [],
      selectedEc: [],
      currentPage: 1,
      photoMode: "single_color_bg", // "main"
      bgMode: "", // ""
      isFilterListOpen: false,
      favorite_rings_url: null,
    }
  },

  watch: {
    '$route': {
      immediate: true,
      deep: true,
      handler (to, from) {
        const names = [
          { tagName: "design[]", dataName: "selectedDesigns" },
          { tagName: "taste[]", dataName: "selectedTastes" },
          { tagName: "metal[]", dataName: "selectedMetals" },
          { tagName: "tanzo[]", dataName: "selectedTanzos" },
          { tagName: "texture[]", dataName: "selectedTextures" },
          { tagName: "diamond[]", dataName: "selectedDiamonds" },
          { tagName: "type[]", dataName: "selectedTypes" },
          { tagName: "series[]", dataName: "selectedSeries" },
          { tagName: "otherFilter[]", dataName: "selectedOtherFitlers" },
          { tagName: "ec[]", dataName: "selectedEc" },
        ]

        names.forEach((n) => {
          if ( to.query[n.tagName] && Array.isArray(to.query[n.tagName]) ) {
            this[n.dataName] = JSON.parse(JSON.stringify(to.query[n.tagName]))
          } else if ( to.query[n.tagName] ) {
            this[n.dataName] = [ to.query[n.tagName] ] || []
          } else {
            this[n.dataName] = []
          }
        })

        this.currentPage = 1
        if (to.query["page"]) {
          this.currentPage = Number.parseInt(to.query["page"])
        }
      },
    },
  },

  methods: {
    setParamForRingImgs () {
      if ([].includes(this.$pathname)) {
        this.photoMode = "main"
        this.bgMode = ""
      }
    },
    onItemClick (e, v, dataName) {
      if (this[dataName].includes(v)) {
        this[dataName] = this[dataName].filter(t => t !== v)
      } else {
        this[dataName] = this[dataName].concat(v)
      }

      this.pushRoute()
    },
    onItemClick({ dataName, item }) {
      if (this[dataName].includes(item)) {
        this[dataName] = this[dataName].filter(t => t !== item)
      } else {
        this[dataName] = this[dataName].concat(item)
      }
      this.pushRoute()
    },
    onItemClickSetOne (e, v, dataName) {
      if (this[dataName].includes(v)) {
        this[dataName] = this[dataName].filter(t => t !== v)
      } else {
        this[dataName] = [v]
      }

      this.pushRoute()
    },
    onClearClick (e) {
      this.selectedDesigns = []
      this.selectedTastes = []
      this.selectedMetals = []
      this.selectedTanzos = []
      this.selectedTextures = []
      this.selectedDiamonds = []
      this.selectedTypes = []
      this.selectedSeries = []
      this.selectedOtherFitlers = []
      this.selectedEc = []

      this.pushRoute()
    },
    onFilterToggleClick (e) {
      this.isFilterListOpen = !this.isFilterListOpen;
    },
    pushRoute () {
      const query = {
        'design[]': this.selectedDesigns,
        'taste[]': this.selectedTastes,
        'metal[]': this.selectedMetals,
        'tanzo[]': this.selectedTanzos,
        'texture[]': this.selectedTextures,
        'diamond[]': this.selectedDiamonds,
        'type[]': this.selectedTypes,
        'series[]': this.selectedSeries,
        'otherFilter[]': this.selectedOtherFitlers,
        'ec[]': this.selectedEc,
        'debug': this.$route.query.debug,
        'photoMode': this.$route.query.photoMode,
      }
      this.$router.push({
        path: "/",
        query: query,
      }) .catch(err => {})
    },
  },

  created () {
    const url = `/api/collections/tags`
    const pathname = this.$pathname
    const queryParams = this.$router.resolve({
      path: '',
      query: this.$route.query,
    }).resolved.fullPath.substring(1)
    this.setParamForRingImgs()
    Http.get(url + pathname + queryParams)
      .then(response => {
        this.designs = response.data.designs || []
        this.tastes = response.data.tastes || []
        this.metals = response.data.metals || []
        this.tanzos = response.data.tanzos || []
        this.textures = response.data.textures || []
        this.diamonds = response.data.diamonds || []
        this.types = response.data.types || []
        this.series = response.data.series || []
        this.otherFilters = response.data.otherFilters || []
        this.ec = response.data.ec || []
        this.favorite_rings_url = response.data.favorite_rings_url
        if (response.data.locale) { this.$i18n.locale = response.data.locale.replace(/-/g, '') }
      })
  },
}
</script>

<style lang="scss">
.v-button {
  color: inherit;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  border: 1px solid rgba(214, 214, 214, .5);
  border-radius: 2px;
  text-decoration: none;
  min-height: 40px;
  padding: 5px;
  background: transparent;
  width: -webkit-fill-available;

  &.is-selected {
    background: #2a475a;
    border-color: #2a475a;
    color: #fff;
  }
}
</style>

<style lang="scss" scoped>

.v-wrap {
  max-width: 1200px;
  margin: 0 auto 20px;
  padding: 0 20px;

  /*
  @media screen and (min-width: 900px) {
    display: grid;
    grid-template-columns: 250px 1fr;
    grid-gap: 20px;
  }

  @media screen and (min-width: 1200px) {
    grid-gap: 30px;
  }
  */

  @media screen and (min-width: 1600px) {
    max-width: 1600px;
  }
}

.v-controls {
  @media screen and (min-width: 900px) {
    padding-top: 30px;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto 1fr;
    grid-template-areas:
      "category"
      "debug"
      "filter"
    ;
  }

  &__category {
    grid-area: category;
  }

  &__filter {
    grid-area: filter;
    @media screen and (min-width: 900px) {
      margin-top: 20px;
    }
  }

  &__switchImgs {
  }

  &__debug {
    grid-area: debug;
  }
}

.v-favoriteLink {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: transparent;
  border: 0;
  color: inherit;
  font: inherit;
  padding: 0;
  outline: 0;
  letter-spacing: inherit;
  text-align: inherit;

  font-size: 10px;
  margin: 0 8px 8px 0;
  padding: 4px 8px;
//  color: #a3a3a3;
  border-radius: 2px;

  a {
    text-decoration: none;
  }
}
</style>
